import { render, staticRenderFns } from "./ApplicationList.vue?vue&type=template&id=5f82bc3e&scoped=true"
import script from "./ApplicationList.vue?vue&type=script&lang=js"
export * from "./ApplicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f82bc3e",
  null
  
)

export default component.exports